import React, { Fragment } from 'react';
import styled from 'styled-components';
import '../../../../utils/assertions.es.js';
import { runIfFn } from '../../../../utils/functions.es.js';
import '../../../../utils/responsive.es.js';
import '../../../../utils/scrollIntoView.es.js';
import { spacing, color } from '../../../../utils/theme.es.js';
import '../../../../utils/useEnhancedEffect.es.js';
import 'react-is';
import { forwardRef } from '../../../../system/forwardRef.es.js';
import { List } from '../../../List/List.es.js';
import { Box } from '../../../../primitives/Box/Box.es.js';
import { Center } from '../../../../primitives/Center/Center.es.js';
import { Progress } from '../../../Progress/Progress.es.js';
import { useAutocompleteDropdown } from './AutocompleteContext.es.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const BottomComponent = styled(Box)`
    flex: 1 0 auto;
    position: sticky;
    bottom: -${spacing("xs")};
    background-color: ${color("surface")};
    margin-bottom: -${spacing("xs")};
`;
const DefaultLoadingComponent = () => /* @__PURE__ */ React.createElement(Center, {
  py: "md"
}, /* @__PURE__ */ React.createElement(Progress, {
  size: "md"
}));
const Items = forwardRef((props, ref) => {
  const _a = props, {
    itemProps,
    itemComponent,
    showNoResults,
    noResultsComponent: NoResultsComponent,
    noResultsLabel,
    highlightedIndex,
    getItemsLabel,
    isLoading,
    loadingComponent: LoadingComponent = DefaultLoadingComponent,
    bottomComponent
  } = _a, rest = __objRest(_a, [
    "itemProps",
    "itemComponent",
    "showNoResults",
    "noResultsComponent",
    "noResultsLabel",
    "highlightedIndex",
    "getItemsLabel",
    "isLoading",
    "loadingComponent",
    "bottomComponent"
  ]);
  const { items, isOpen, isGrouped, getDisabledOption, hasReachedMaxValues, inputValue, closeMenu } = useAutocompleteDropdown();
  if (isLoading) {
    return /* @__PURE__ */ React.createElement(Box, __spreadValues({
      flex: "1 1 auto",
      overflowY: "auto",
      position: "relative",
      ref
    }, rest), /* @__PURE__ */ React.createElement(LoadingComponent, null), bottomComponent && /* @__PURE__ */ React.createElement(BottomComponent, null, runIfFn(bottomComponent, { inputValue, closeMenu })));
  }
  if (items.length <= 0 && !isLoading) {
    return showNoResults ? /* @__PURE__ */ React.createElement(Box, __spreadValues({
      flex: "1 1 auto",
      overflowY: "auto",
      py: "xs",
      position: "relative",
      ref
    }, rest), /* @__PURE__ */ React.createElement(NoResultsComponent, null, noResultsLabel), bottomComponent && /* @__PURE__ */ React.createElement(BottomComponent, null, runIfFn(bottomComponent, { inputValue, closeMenu }))) : null;
  }
  const renderGroups = () => items.reduce((acc, item, index) => {
    acc.groups.push(/* @__PURE__ */ React.createElement(Fragment, {
      key: `group-${index}`
    }, /* @__PURE__ */ React.createElement(List.Subheader, null, item.group), item.options.map((option) => {
      const optionIndex = acc.itemIndex++;
      return /* @__PURE__ */ React.createElement(List.Item, __spreadValues({
        key: `option-${optionIndex}`,
        isSelected: highlightedIndex === optionIndex,
        isDisabled: (getDisabledOption == null ? void 0 : getDisabledOption(item)) || hasReachedMaxValues
      }, itemProps({
        item: option,
        index: optionIndex
      })), itemComponent({ item: option, getItemsLabel, closeMenu }));
    })));
    return acc;
  }, { groups: [], itemIndex: 0 }).groups;
  const renderItems = () => items.map((item, index) => /* @__PURE__ */ React.createElement(List.Item, __spreadValues({
    isSelected: highlightedIndex === index,
    key: `option-${index}`,
    isDisabled: (getDisabledOption == null ? void 0 : getDisabledOption(item)) || hasReachedMaxValues
  }, itemProps({ item, index })), itemComponent({ item, getItemsLabel, closeMenu })));
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(List, __spreadValues({
    as: "div",
    flex: "1 1 auto",
    overflowY: "auto",
    py: "xs",
    position: "relative",
    ref
  }, rest), isOpen && (isGrouped ? renderGroups() : renderItems()), bottomComponent && /* @__PURE__ */ React.createElement(BottomComponent, null, runIfFn(bottomComponent, { inputValue, closeMenu }))));
});

export { Items };
//# sourceMappingURL=Items.es.js.map
